var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30859 15C3.30859 17.5 4.14193 18.3333 6.64193 18.3333H13.3086C15.8086 18.3333 16.6419 17.5 16.6419 15V8.33331H3.30859V11.5333",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9173 5.83335V6.66669C17.9173 7.58335 17.4757 8.33335 16.2507 8.33335H3.75065C2.47565 8.33335 2.08398 7.58335 2.08398 6.66669V5.83335C2.08398 4.91669 2.47565 4.16669 3.75065 4.16669H16.2507C17.4757 4.16669 17.9173 4.91669 17.9173 5.83335Z",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70096 4.16668H5.10096C4.81763 3.85835 4.82596 3.38335 5.12596 3.08335L6.30929 1.90001C6.61763 1.59168 7.12596 1.59168 7.43429 1.90001L9.70096 4.16668Z",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.891 4.16668H10.291L12.5577 1.90001C12.866 1.59168 13.3743 1.59168 13.6827 1.90001L14.866 3.08335C15.166 3.38335 15.1743 3.85835 14.891 4.16668Z",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44922 8.33331V12.6166C7.44922 13.2833 8.18255 13.675 8.74089 13.3166L9.52422 12.8C9.80755 12.6166 10.1659 12.6166 10.4409 12.8L11.1826 13.3C11.7326 13.6666 12.4742 13.275 12.4742 12.6083V8.33331H7.44922Z",
    stroke: "#D5D8DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.0d734749106b174059464b7692a29a93.svg";
export { ForwardRef as ReactComponent };